import { envConfig } from '../../../env';
import { Post } from '@/service/request/server';
import { applyTicket } from '@/utils/security';

const baseApi = () => {
    function queryUserDetailInfo() {
        return Post(`${envConfig.getCurrentApi()}/cotton/` + 'web/queryUserDetailInfo', null);
    }

    function sendPhoneCaptchaByAccount(data) {
        return Post(`${envConfig.getCurrentApi()}/cotton/` + 'sendCaptchaByAccount', data);
    }

    function sendEmailCaptchaByAccount(data) {
        data.systemLanguage = getUserLanguage();
        return Post(`${envConfig.getCurrentApi()}/cotton/` + 'sendEmailCaptchaByAccount', data);
    }

    function checkPhoneCaptcha(data) {
        return Post(`${envConfig.getCurrentApi()}/cotton/` + 'checkPhoneCaptcha', data);
    }

    function checkEmailCaptcha(data) {
        return Post(`${envConfig.getCurrentApi()}/cotton/` + 'checkEmailCaptcha', data);
    }

    function updateOrAddPhone(data) {
        return Post(`${envConfig.getCurrentApi()}/cotton/` + 'updateOrAddPhone', data);
    }

    function updateOrAddEmail(data) {
        return Post(`${envConfig.getCurrentApi()}/cotton/` + 'web/updateOrAddEmail', data);
    }

    function sendCaptchaByPhone(data) {
        let header = {};
        return applyTicket(header, 'SMS', data.phone).then(result => {
            return Post(`${envConfig.getCurrentApi()}/cotton/` + 'sendCaptchaByPhone', data, { headers: header });
        });
    }

    function sendCaptchaByEmail(data) {
        let header = {};
        data.systemLanguage = getUserLanguage();
        return applyTicket(header, 'EMAIL', data.email).then(result => {
            return Post(`${envConfig.getCurrentApi()}/cotton/` + 'sendEmailSms', data, { headers: header });
        });
    }

    function updatePassword(data) {
        return Post(`${envConfig.getCurrentApi()}/cotton/` + 'updatePassword', data);
    }

    function updatePasswordByPhone(data) {
        return Post(`${envConfig.getCurrentApi()}/cotton/` + 'updatePwdByPhone', data);
    }

    function updatePasswordByEmail(data) {
        return Post(`${envConfig.getCurrentApi()}/cotton/` + 'web/updatePasswordByEmail', data);
    }

    function queryAccountInfoByContact(data) {
        return Post(`${envConfig.getCurrentApi()}/cotton/` + 'web/queryAccountInfoByContact', data);
    }

    function judgeCaptchaByContact(data) {
        return Post(`${envConfig.getCurrentApi()}/cotton/` + 'web/judgeCaptchaByContact', data);
    }

    function updateUserInfo(data) {
        return Post(`${envConfig.getCurrentApi()}/cotton/` + 'web/updateUserInfo', data);
    }

    function deletePlayer() {
        return Post(`${envConfig.getCurrentApi()}/cotton/` + 'deletePlayer', {});
    }

    function thirdAccountList() {
        return Post(`${envConfig.getCurrentApi()}/cotton/` + '/account/connectAccountList', {});
    }

    function disconnectThirdAccount(thirdAccountId) {
        return Post(`${envConfig.getCurrentApi()}/cotton/` + `/account/disconnect/${thirdAccountId}`, {});
    }

    function getUserLanguage() {
        let language = navigator.language.toLowerCase();
        if (language.startsWith('zh')) {
            return 'Chinese';
        } else {
            return 'English';
        }
    }

    return {
        sendPhoneCaptchaByAccount,
        sendEmailCaptchaByAccount,
        sendCaptchaByPhone,
        sendCaptchaByEmail,
        checkPhoneCaptcha,
        checkEmailCaptcha,
        updateOrAddPhone,
        updateOrAddEmail,
        updatePassword,
        updatePasswordByPhone,
        updatePasswordByEmail,
        queryAccountInfoByContact,
        judgeCaptchaByContact,
        updateUserInfo,
        deletePlayer,
        queryUserDetailInfo,
        thirdAccountList,
        disconnectThirdAccount
    };
};

export const accountApi = baseApi();
